module.exports = __webpack_public_path__ + "img/170.ff0ec67e.jpg";